import {LogService} from '../services/log.service';
import {SecurityService} from '../services/security.service';
import {VisualsService} from '../services/visuals.service';
import {BaseGridComponent} from './basegrid.component';
import {GridService} from './grid.service';

export class BaseGridNoCookieComponent<
  G extends GridService,
> extends BaseGridComponent<GridService> {
  constructor(
    public securityService: SecurityService,
    public logger: LogService,
    public visualsService: VisualsService,
    public gridService: G,
    group?: string,
  ) {
    super(securityService, logger, visualsService, gridService, group);
    this.cookieId = -1;
  }

  /**
   * All @function *Params() affecting grid must carry the filter params
   * @param this.cookieId is removed
   */
  public dataCountParams(): any {
    return Object.assign({group: this.group}, this.initParams);
  }

  public dataParams(): any {
    let firstRow = 1 + this.pageSize * (this.pageNum - 1);
    let lastRow = firstRow + this.pageSize - 1;

    return Object.assign({}, this.initParams, {
      group: this.group,
      start: firstRow,
      end: lastRow,
      order: this.sort,
    });
  }

  public footerDataParams(): any {
    return Object.assign({group: this.group}, this.initParams);
  }

  public headerDataParams(): any {
    return Object.assign({group: this.group}, this.initParams);
  }

  public txtParams(): any {
    return Object.assign({}, this.initParams, {
      order: this.sort,
      group: this.group,
    });
  }

  public csvParams(): any {
    return Object.assign({}, this.initParams, {
      order: this.sort,
      group: this.group,
    });
  }

  public xlsParams(): any {
    return Object.assign({}, this.initParams, {
      order: this.sort,
      group: this.group,
    });
  }

  public pdfParams(): any {
    return Object.assign({}, this.initParams, {
      order: this.sort,
      group: this.group,
    });
  }

  /**
   * no procedures used with @function getInitData() so service call is skipped
   * The call hierarchy remains intact.
   */
  public getInitData(): void {
    if (this.continueWithSearch) {
      this.loading = true;
      this.searched = true;
      this.getColumnDefinition();
      this.getGridActions();
      this.getCheckboxCallback();
    }
  }

  /**
   * Grid checkboxes without db interaction
   */

  public getCheckboxCallback() {}

  public dataCheckboxInit() {
    this.grid.forEach((record) => {
      record['selected'] = 'N';
      if (this.checkboxPKArray && this.checkboxPKArray.includes(record[this.checkboxPK])) {
        record['selected'] = 'Y';
      }
    });
  }

  public checkToggle(params) {
    this.checkboxLoading = true;
    this.searched = true;
    if (params['selected'] != null && params['selected'] != '') {
      if (params[this.checkboxPK] && params[this.checkboxPK] != '') {
        if (params['selected'] == 'Y') {
          //remove from array of pks
          let index = this.checkboxPKArray.indexOf(params[this.checkboxPK]);
          if (index > -1) {
            this.checkboxPKArray.splice(index, 1);
          }
          this.dataCheckboxInit();
        } else {
          //add to array of pks
          this.checkboxPKArray.push(params[this.checkboxPK]);
          this.dataCheckboxInit();
        }
      } else {
        this.logger.error('Object property "checkboxPK" missing.');
      }
    } else {
      this.logger.error('Object property "selected" missing.');
    }
    this.checkboxLoading = false;
  }

  public selectAll(params) {
    this.checkboxLoading = true;
    this.checkboxPKArray = Object.assign([], this.checkboxPKArrayFull);
    this.dataCheckboxInit();
    this.checkboxLoading = false;
  }

  public deselectAll(params) {
    this.checkboxLoading = true;
    this.checkboxPKArray = [];
    this.dataCheckboxInit();
    this.checkboxLoading = false;
  }
}
